<template>
  <div class="fire-stat-alarm">
    <MCard :title="$t('报警统计')" title-align="center">
      <StatPage
        :formModel="formModel"
        :requestData="requestData"
        :formButton="formButton"
        :deviceModelBusiType="13"
      />
    </MCard>
  </div>
</template>

<script>
import { merge } from 'lodash';
import { getAlarmData } from '@/api/stat';
import { canvasToImg, downFile, dayTime } from '@/utils/utils';

export default {
  name: 'StatAlarm',
  components: {
    MCard: () => import('@/components/mCard/index.vue'),
    StatPage: () => import('@/views/statistics/components/stat-common.vue')
  },
  data() {
    return {
      requestData: {},
      formModel: {
        sn: [],
        // alarmType: [],
        busiType: [],
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()]
        // deviceModel: []
      },
      formButton: [
        {
          text: '查询',
          event: this.search
        },
        {
          text: '导出',
          code: '010611',
          loading: false,
          event: this.hisExport
        }
      ]
    };
  },
  methods: {
    getAlarmDataPro() {
      return getAlarmData(
        merge(
          {
            beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
            endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1]
          },
          this.formModel
        )
      );
    },
    search() {
      this.getAlarmDataPro().then(res => {
        this.requestData = res.data;
      });
    },
    hisExport(op) {
      op.loading = true;
      this.getAlarmDataPro().then(res => {
        this.requestData = res.data;
        this.$nextTick().then(() => {
          canvasToImg().then(imgs => {
            downFile({
              url: '/stat/genAlarmDataReport',
              method: 'post',
              data: merge(
                {
                  beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
                  endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1],
                  pics: imgs
                },
                this.formModel
              )
            }).finally(() => {
              op.loading = false;
            });
          });
        });
      });
    }
  }
};
</script>

<style lang="scss">
.fire-stat-alarm {
  width: calc(100% - 155px);
  height: calc(100% - 30px);
  margin-left: var(--gap);
  box-sizing: border-box;

  .m-card_content {
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
    @include scrollar-style-thin;
  }
}
</style>
